import { ReplicaLink } from './replica-link';

export class PodReplicaLink extends ReplicaLink {
    lagHistoryMetrics: [number, number][];

    constructor(json: any) {
        super(json);
    }
}
